var _style, _path, _path2, _polyline, _polygon, _polygon2, _polygon3, _line, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSafari(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-162 98 367 367",
    xmlSpace: "preserve",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:#CD151E;}\n\t.st3{fill:#FA5153;}\n\t.st4{fill:#ACACAC;}\n\t.st5{fill:#EEEEEE;}\n\t.st6{fill:#E9E9E9;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -229,
    y1: 531,
    x2: -228,
    y2: 531,
    gradientTransform: "matrix(0 -365 365 0 -193794 -83121.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DBDBDA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#DBDBDA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-2.6,113.8c8-1.2,16.2-1.8,24.6-1.8c93.2,0,168.8,75.6,168.8,168.8c0,85.2-63.2,155.7-145.2,167.2 c-8,1.2-16.2,1.8-24.6,1.8c-93.2,0-168.8-75.6-168.8-168.8C-147.8,195.8-84.7,125.3-2.6,113.8 M21,98.5 c-100.8,0-182.5,81.7-182.5,182.5S-79.8,463.5,21,463.5S203.5,381.8,203.5,281S121.8,98.5,21,98.5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: -229,
    cy: 531,
    r: 1,
    gradientTransform: "matrix(214.7512 0 0 -214.7512 49231.5195 114283.8203)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#69BEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0072C4"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21,112.2c-8,0-15.9,0.6-23.6,1.6c-81.6,11.9-144.2,82.2-144.2,167.1c0,93.2,75.6,168.8,168.8,168.8 c8,0,15.9-0.6,23.6-1.6c81.6-11.9,144.2-82.2,144.2-167C189.8,187.8,114.2,112.2,21,112.2"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "136.3,165.7 1.8,261.3 41.7,301 136.3,165.7  "
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "1.9,261 22,280.9 136.3,165.7  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1.9,261 41.8,300.7 -92.8,396.3  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "-92.8,396.3 22,280.9 1.9,261  "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 111.7,
    y1: 413.6,
    x2: 111.7,
    y2: 413.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M123.8,405.6c-0.4,0.3-0.9,0.5-1.4,0.5C122.9,406.1,123.4,406,123.8,405.6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M124,405.5c0,0-0.1,0.1-0.2,0.1C123.9,405.6,123.9,405.5,124,405.5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M69.4,399.4c-0.5,0.4-0.7,1.1-0.6,1.7C68.7,400.5,69,399.8,69.4,399.4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M145.9,383.5C145.9,383.5,145.9,383.6,145.9,383.5C145.9,383.6,145.9,383.5,145.9,383.5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M146,383.4c-0.1,0.1-0.1,0.1-0.2,0.2C145.9,383.5,146,383.4,146,383.4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M146.5,382.1c0,0.4-0.2,0.9-0.5,1.2C146.4,383,146.5,382.6,146.5,382.1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M177,314.5c0.1,0,0.2,0,0.3,0h0.1h-0.1C177.2,314.5,177.1,314.5,177,314.5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M181.8,296.9c0,0.1,0,0.2,0,0.2C181.8,297,181.8,297,181.8,296.9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M181.8,265.6L181.8,265.6c0,0.1,0,0.2,0,0.3C181.8,265.8,181.8,265.7,181.8,265.6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M175.7,235.7c-0.2,0.5-0.7,0.9-1.2,1.1l-12.5,4.1c-0.1,0-0.1,0-0.2,0.1c0.1,0,0.2,0,0.3-0.1l12.5-4.1 C175.1,236.6,175.5,236.2,175.7,235.7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M130.4,211.1c-0.3,0.2-0.6,0.3-1,0.3C129.7,211.4,130.1,211.3,130.4,211.1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M113.2,169.8c0.4,0.3,0.8,0.5,1.2,0.5C114,170.2,113.6,170.1,113.2,169.8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M113.1,169.6c0.1,0.1,0.1,0.1,0.2,0.2C113.2,169.7,113.1,169.7,113.1,169.6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M54.5,124.6c0,0.1,0,0.3,0,0.4C54.5,124.9,54.5,124.8,54.5,124.6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M5.4,442.1c-0.1,0-0.2,0-0.2,0c-1.3-0.1-2.1-1.1-2.1-2.3l1-13.3c0.1-1.2,1-2,2.1-2c0.1,0,0.2,0,0.3,0 c1.3,0.1,2.1,1.1,2.1,2.3l-1,13.3C7.5,441.2,6.6,442.1,5.4,442.1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M37.4,442c-1.2,0-2.2-0.8-2.3-1.9L33.4,427c-0.1-1.1,0.7-2.3,2-2.4c0.1,0,0.2,0,0.3,0c1.2,0,2.2,0.8,2.3,1.9 l1.7,13.1c0.1,1.1-0.7,2.3-2,2.4C37.6,442,37.5,442,37.4,442"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M67.7,435.8c-0.9,0-1.7-0.5-2.1-1.4l-4.1-12.5c-0.3-1.1,0.3-2.4,1.4-2.9c0.3-0.1,0.5-0.1,0.8-0.1 c0.9,0,1.7,0.5,2.1,1.4l4.1,12.5c0.1,0.2,0.1,0.5,0.1,0.7c0,0.6-0.3,1.2-0.7,1.6c-0.2,0.2-0.5,0.4-0.8,0.5 C68.2,435.8,68,435.8,67.7,435.8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-25.5,436c-0.2,0-0.3,0-0.5-0.1c-1.1-0.3-2-1.6-1.6-2.7l3.6-12.8c0.2-1,1.1-1.6,2.1-1.6c0.2,0,0.4,0,0.6,0.1 c1.1,0.3,2,1.6,1.6,2.7l-3.6,12.8c-0.1,0.4-0.3,0.7-0.5,0.9C-24.3,435.8-24.9,436-25.5,436"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M20.7,442.7c-1.3,0-2.3-1-2.3-2.1v-29.8c0-1.1,1.1-2.1,2.3-2.1c1.3,0,2.3,1,2.3,2.1v29.8 C23,441.7,22,442.7,20.7,442.7"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M88.2,411.2c-0.6-1-0.3-2.3,0.9-3c0.4-0.2,0.8-0.3,1.2-0.3c0.7,0,1.4,0.3,1.8,1l6.6,11.5c0.6,1,0.3,2.4-0.9,3 c-0.4,0.2-0.8,0.3-1.2,0.3c-0.7,0-1.4-0.3-1.8-1L88.2,411.2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-54.5,424c-0.3,0-0.7-0.1-1-0.3c-1.1-0.6-1.6-1.9-1-3l6-11.8c0.4-0.8,1.2-1.2,2-1.2c0.3,0,0.7,0.1,1,0.3 c1.1,0.6,1.6,1.9,1,3l-6,11.8C-53,423.5-53.7,424-54.5,424"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-10.4,439.6c-0.2,0-0.3,0-0.5-0.1c-1.3-0.3-2-1.4-1.9-2.6l5.8-29.2c0.3-1,1.2-1.7,2.4-1.7c0.1,0,0.2,0,0.3,0 c1.3,0.3,2,1.4,1.9,2.6l-5.8,29.2C-8.5,438.8-9.4,439.6-10.4,439.6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M44.5,408.6c-0.3-1.1,0.4-2.3,1.7-2.6c0.2,0,0.3-0.1,0.5-0.1c1.1,0,2,0.8,2.2,1.8l6,29.2 c0.3,1.1-0.6,2.4-1.7,2.6c-0.2,0-0.3,0.1-0.5,0.1c-0.4,0-0.8-0.1-1.1-0.3c-0.6-0.3-1-0.8-1.1-1.4L44.5,408.6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M82.4,430.4c-0.9,0-1.7-0.5-2.1-1.3l-11.5-27.5c-0.4-1,0.1-2.3,1.3-2.9c0.3-0.1,0.6-0.2,0.9-0.2 c0.9,0,1.7,0.5,2.1,1.3l11.5,27.5c0.4,1.1-0.1,2.4-1.3,2.9C83,430.4,82.7,430.4,82.4,430.4"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-40.5,430.4c-0.3,0-0.6-0.1-1-0.2c-1.1-0.4-1.7-1.7-1.3-2.9l11.4-27.5c0.4-0.8,1.2-1.4,2.1-1.4 c0.3,0,0.6,0.1,0.9,0.2c1.1,0.4,1.7,1.7,1.3,2.9L-38.5,429C-38.8,430-39.6,430.4-40.5,430.4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M122.5,406.5c-0.6,0-1.2-0.3-1.7-0.7l-8.7-10c-0.7-1-0.7-2.4,0.3-3.1c0.5-0.4,1-0.6,1.5-0.6 c0.6,0,1.2,0.3,1.7,0.7l8.7,10c0.9,0.9,0.7,2.3-0.3,3.1C123.5,406.3,123,406.5,122.5,406.5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M109.7,415.8c-0.7,0-1.4-0.3-1.9-1l-16.5-24.7c-0.7-1.1-0.4-2.4,0.7-3.1c0.4-0.3,0.8-0.4,1.3-0.4 c0.7,0,1.4,0.3,1.9,1l16.5,24.7c0.7,1,0.4,2.4-0.7,3.1C110.6,415.7,110.2,415.8,109.7,415.8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-68.1,415.6c-0.4,0-0.9-0.1-1.3-0.4c-1-0.7-1.3-2.1-0.7-3.1l16.5-24.7c0.4-0.6,1.2-1,1.9-1 c0.4,0,0.9,0.1,1.3,0.4c1,0.7,1.3,2.1,0.7,3.1l-16.5,24.7C-66.7,415.2-67.4,415.6-68.1,415.6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M144.6,384.4c-0.5,0-1-0.1-1.4-0.4l-10.4-8.1c-1-0.7-1.1-2.1-0.4-3.1c0.4-0.6,1.1-0.9,1.7-0.9 c0.5,0,1,0.1,1.4,0.4l10.4,8.1c1,0.7,1.1,2.1,0.4,3.1C145.9,384.1,145.3,384.4,144.6,384.4"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-102.7,384.1c-0.6,0-1.3-0.3-1.8-0.8c-0.9-1-0.7-2.4,0.1-3.1l10.1-8.6c0.4-0.4,0.9-0.6,1.4-0.6 c0.6,0,1.3,0.3,1.8,0.8c0.9,1,0.7,2.4-0.1,3.1l-10.1,8.6C-101.7,383.9-102.2,384.1-102.7,384.1"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M133.9,396c-0.6,0-1.1-0.2-1.6-0.6l-21.1-21c-1-0.9-1-2.3,0-3.1c0.4-0.4,1-0.6,1.6-0.6s1.1,0.2,1.6,0.6 l21.1,21c0.9,0.9,0.9,2.3,0,3.1C135.1,395.8,134.5,396,133.9,396"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-92.3,395.4c-0.6,0-1.1-0.2-1.6-0.6c-0.9-0.9-0.9-2.3,0-3.1l21.1-21c0.4-0.4,1-0.6,1.6-0.6s1.1,0.2,1.6,0.6 c0.9,0.9,0.9,2.3,0,3.1l-21.1,21C-91.2,395.2-91.8,395.4-92.3,395.4"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M153.6,372c-0.4,0-0.8-0.1-1.1-0.3l-24.8-16.5c-1.1-0.7-1.3-2.1-0.6-3.1c0.5-0.7,1.2-1,2-1 c0.4,0,0.8,0.1,1.1,0.3l24.8,16.5c1,0.7,1.3,2,0.6,3.1C155.1,371.6,154.3,372,153.6,372"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-112,371.5c-0.7,0-1.5-0.4-1.9-1.1c-0.7-1-0.4-2.4,0.6-3.1l24.8-16.5c0.4-0.3,0.8-0.4,1.2-0.4 c0.7,0,1.5,0.4,1.9,1.1c0.7,1,0.4,2.4-0.6,3.1l-24.8,16.5C-111.1,371.4-111.5,371.5-112,371.5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M149,352.3c-1.1-0.4-1.6-1.9-1-3c0.4-0.8,1.2-1.2,2-1.2c0.3,0,0.7,0.1,1,0.3l11.8,6c1.1,0.6,1.6,1.9,1,3 c-0.4,0.8-1.2,1.2-2,1.2c-0.3,0-0.7-0.1-1-0.3L149,352.3"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-122.2,355.9c0-0.8,0.3-1.5,1-1.9l11.5-6.6c0.3-0.2,0.7-0.3,1-0.3c0.8,0,1.6,0.4,2,1.1c0.6,1.1,0.3,2.4-0.7,3 l-11.5,6.6c-0.3,0.2-0.7,0.3-1,0.3c0,0,0,0-0.1,0c0,0,0,0-0.1,0c-0.7,0-1.5-0.4-1.9-1.1C-122.1,356.6-122.2,356.2-122.2,355.9"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M168.2,344.6c-0.3,0-0.5,0-0.8-0.1L139.9,333c-1.1-0.6-1.6-1.9-1.1-3c0.3-0.9,1.2-1.4,2.1-1.4 c0.3,0,0.5,0,0.8,0.1l27.5,11.4c1,0.4,1.4,1.3,1.3,2.4c0,0.2-0.1,0.4-0.1,0.6C169.9,344.1,169.1,344.6,168.2,344.6"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-128.7,341.6c0-0.9,0.4-1.7,1.3-2.1l27.5-11.4c0.3-0.1,0.5-0.1,0.8-0.1c0.9,0,1.7,0.5,2.1,1.4 c0.4,1.1,0,2.4-1.1,3l-27.5,11.4c-0.3,0.1-0.5,0.1-0.8,0.1c-0.9,0-1.7-0.5-2.1-1.4C-128.7,342.2-128.7,341.9-128.7,341.6"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M173.9,329.7c-0.2,0-0.4,0-0.6-0.1l-12.8-3.6c-1.1-0.3-1.9-1.4-1.6-2.7c0.2-0.9,1.1-1.7,2.1-1.7 c0.2,0,0.4,0,0.6,0.1l12.8,3.6c0.4,0.1,0.7,0.3,0.9,0.5c0.6,0.5,0.8,1.4,0.6,2.2C175.7,329,174.8,329.7,173.9,329.7"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-131.8,329.3c-0.9,0-1.8-0.6-2.2-1.6c-0.4-1.1,0.1-2.4,1.4-2.9l12.5-4.1c0.2,0,0.4-0.1,0.6-0.1 c1,0,1.9,0.6,2.3,1.5c0.4,1.1-0.1,2.4-1.4,2.9l-12.5,4.1C-131.3,329.3-131.5,329.3-131.8,329.3"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M177.3,314.8c-0.1,0-0.2,0-0.3,0l-29.2-5.8c-1.1-0.3-1.9-1.4-1.7-2.7c0.3-1.2,1.2-1.9,2.3-1.9 c0.1,0,0.2,0,0.3,0l29.2,5.8c1.1,0.3,2,1.4,1.7,2.7C179.3,314.1,178.3,314.8,177.3,314.8"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-136.7,309.5c0.2-0.1,0.5-0.2,0.7-0.3l29.2-5.7c0.1,0,0.3-0.1,0.4-0.1c1,0,1.9,0.8,2.1,1.9 c0.3,1.3-0.6,2.4-1.7,2.7l-29.2,5.7c-0.1,0-0.3,0.1-0.4,0.1c-1,0-1.9-0.8-2.1-1.9c0-0.2-0.1-0.3-0.1-0.5 C-137.8,310.6-137.4,309.9-136.7,309.5"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M179.7,299.3l-13.3-1c-1.1-0.1-2-1.3-2-2.4c0.1-1.3,1.1-2.1,2.3-2.1l13.3,1c1.1,0.1,2.1,1.1,2,2.4 C181.8,298.4,180.8,299.3,179.7,299.3"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-137.8,298.6c-1.1,0-2-0.8-2.2-2c-0.1-1.3,0.7-2.4,1.9-2.6l13.1-1.6c0.1,0,0.2,0,0.2,0c1.1,0,2,0.8,2.2,2 c0.1,1.3-0.7,2.4-1.9,2.6l-13.1,1.6C-137.6,298.5-137.7,298.6-137.8,298.6"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M150.7,283.7c-1.1,0-2.1-1-2.1-2.3s1-2.3,2.1-2.3h29.8c1.1,0,2.1,1,2.1,2.3s-1,2.3-2.1,2.3H150.7"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-138.5,282.9c-1.1,0-2.1-1-2.1-2.3c0-1.3,1-2.3,2.1-2.3h29.8c1.1,0,2.1,1,2.1,2.3c0,1.3-1,2.3-2.1,2.3H-138.5 "
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M166.8,269.6c-1.1,0-2-0.8-2.2-2c-0.1-1.3,0.7-2.4,1.9-2.6l13.1-1.6c0.1,0,0.2,0,0.2,0c1.1,0,2,0.8,2.2,2 c0.1,1.3-0.7,2.4-1.9,2.6l-13.1,1.6C166.9,269.6,166.8,269.6,166.8,269.6"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-124.7,268.3l-13.3-1c-1.1-0.1-2.1-1.1-2-2.4s1.1-2.1,2.3-2.1l13.3,1c1.1,0.1,2,1.3,2,2.4 C-122.6,267.5-123.6,268.3-124.7,268.3"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M148.3,258.5c-1,0-1.9-0.8-2.1-1.9c-0.3-1.3,0.6-2.4,1.7-2.7l29.2-5.7c0.1,0,0.3-0.1,0.4-0.1 c1,0,1.9,0.8,2.1,1.9c0,0.2,0.1,0.3,0.1,0.5c0.1,0.8-0.4,1.6-1.1,1.9c-0.2,0.1-0.5,0.2-0.7,0.3l-29.2,5.7 C148.6,258.5,148.5,258.5,148.3,258.5"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-106.3,257.6c-0.1,0-0.2,0-0.3,0l-29.2-5.8c-1.1-0.3-2-1.4-1.7-2.7c0.3-1.2,1.2-1.9,2.3-1.9 c0.1,0,0.2,0,0.3,0l29.2,5.8c1.1,0.3,1.9,1.4,1.7,2.7C-104.3,256.9-105.3,257.6-106.3,257.6"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M173.1,232.8c0.2-0.1,0.4-0.1,0.6-0.1c0,0,0,0,0.1,0c0.9,0,1.8,0.6,2.2,1.6c0.4,1.1-0.1,2.4-1.4,2.9l-12.5,4.1 c-0.2,0-0.4,0.1-0.6,0.1c-1,0-1.9-0.6-2.3-1.5c-0.4-1.1,0.1-2.4,1.4-2.9L173.1,232.8"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-133.3,236.1c-0.6-0.5-0.8-1.4-0.6-2.2c0.2-0.9,1.1-1.7,2.1-1.7c0.2,0,0.4,0,0.6,0.1l12.8,3.6 c1.1,0.3,1.9,1.4,1.6,2.7c-0.2,0.9-1.1,1.7-2.1,1.7c-0.2,0-0.4,0-0.6-0.1l-12.8-3.6C-132.8,236.6-133.1,236.4-133.3,236.1"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M141.1,234.1c-0.9,0-1.7-0.5-2.1-1.4c-0.4-1.1,0-2.4,1.1-3l27.5-11.4c0.3-0.1,0.5-0.1,0.8-0.1 c0.9,0,1.7,0.5,2.1,1.4c0.1,0.3,0.2,0.6,0.2,0.9c0,0.9-0.4,1.7-1.3,2.1L141.9,234C141.6,234,141.4,234.1,141.1,234.1"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-128.3,218.8c0.3-0.9,1.2-1.4,2.1-1.4c0.3,0,0.5,0,0.8,0.1l27.5,11.4c1.1,0.6,1.6,1.9,1.1,3 c-0.3,0.9-1.2,1.4-2.1,1.4c-0.3,0-0.5,0-0.8-0.1l-27.5-11.4c-1-0.4-1.4-1.3-1.3-2.4C-128.4,219.2-128.4,219-128.3,218.8"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M161.9,203.9C161.9,203.9,162,203.9,161.9,203.9c0.8,0,1.5,0.4,1.9,1.1c0.2,0.4,0.3,0.8,0.3,1.1 c0,0.8-0.3,1.5-1,1.9l-11.5,6.6c-0.3,0.2-0.7,0.3-1,0.3c-0.8,0-1.6-0.4-2-1.1c-0.6-1.1-0.3-2.4,0.7-3l11.5-6.6 C161.2,204,161.5,203.9,161.9,203.9"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-108,214c-0.3,0-0.7-0.1-1-0.3l-11.8-6c-1.1-0.6-1.6-1.9-1-3c0.4-0.8,1.2-1.2,2-1.2c0.3,0,0.7,0.1,1,0.3 l11.8,6c1.1,0.4,1.6,1.9,1,3C-106.4,213.5-107.2,214-108,214"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M129.3,211.7c-0.7,0-1.5-0.4-1.9-1.1c-0.7-1-0.4-2.4,0.6-3.1l24.8-16.5c0.4-0.3,0.8-0.4,1.2-0.4 c0.7,0,1.5,0.4,1.9,1.1c0.7,1,0.4,2.4-0.6,3.1l-24.8,16.5C130.1,211.5,129.7,211.7,129.3,211.7"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-87.1,211c-0.4,0-0.8-0.1-1.1-0.3l-24.7-16.5c-1-0.7-1.3-2-0.6-3.1c0.5-0.7,1.2-1,2-1c0.4,0,0.8,0.1,1.1,0.3 l24.7,16.5c1.1,0.7,1.3,2.1,0.6,3.1C-85.5,210.7-86.3,211-87.1,211"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M134.8,191c-0.6,0-1.3-0.3-1.8-0.8c-0.9-1-0.7-2.4,0.1-3.1l10.1-8.6c0.4-0.4,0.9-0.6,1.4-0.6 c0.6,0,1.3,0.3,1.8,0.8c0.9,1,0.7,2.4-0.1,3.1l-10.1,8.6C135.8,190.8,135.3,191,134.8,191"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-92.1,190.2c-0.5,0-1-0.1-1.4-0.4l-10.4-8.1c-1-0.7-1.1-2.1-0.4-3.1c0.4-0.6,1.1-0.9,1.7-0.9 c0.5,0,1,0.1,1.4,0.4l10.4,8.1c1,0.7,1.1,2.1,0.4,3.1C-90.8,189.9-91.4,190.2-92.1,190.2"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-70.8,191.4c-0.6,0-1.1-0.2-1.6-0.6l-21.1-21c-0.9-0.9-0.9-2.3,0-3.1c0.4-0.4,1-0.6,1.6-0.6s1.1,0.2,1.6,0.6 l21.1,21c1,0.9,1,2.3,0,3.1C-69.7,191.2-70.2,191.4-70.8,191.4"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M114.6,170.5c-0.5,0-1-0.2-1.5-0.6c-1-0.7-1.1-2.1-0.4-3.1l8.3-10.4c0.4-0.6,1-0.8,1.7-0.8 c0.5,0,1,0.2,1.5,0.6c1,0.7,1.1,2.1,0.4,3.1l-8.3,10.4C115.8,170.2,115.2,170.5,114.6,170.5"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-71.9,169.9c-0.6,0-1.2-0.3-1.7-0.7l-8.7-10c-0.9-0.9-0.7-2.3,0.3-3.1c0.5-0.4,1-0.6,1.5-0.6 c0.6,0,1.2,0.3,1.7,0.7l8.7,10c0.7,1,0.7,2.4-0.3,3.1C-70.9,169.8-71.4,169.9-71.9,169.9"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M93.7,175.6c-0.4,0-0.9-0.1-1.3-0.4c-1-0.7-1.3-2.1-0.7-3.1l16.5-24.7c0.4-0.6,1.1-1,1.8-1 c0.4,0,0.9,0.1,1.3,0.4c1,0.7,1.3,2.1,0.7,3.1l-16.5,24.7C95.1,175.3,94.4,175.6,93.7,175.6"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-51.3,175.3c-0.7,0-1.4-0.3-1.9-1l-16.5-24.7c-0.7-1-0.4-2.4,0.7-3.1c0.4-0.3,0.8-0.4,1.3-0.4 c0.7,0,1.4,0.3,1.9,1l16.5,24.7c0.7,1.1,0.4,2.4-0.7,3.1C-50.4,175.2-50.8,175.3-51.3,175.3"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-54.5,138.3L-54.5,138.3c0.7,0,1.4,0.3,1.8,1l6.6,11.5c0.6,1,0.3,2.3-0.9,3c-0.4,0.2-0.8,0.3-1.2,0.3 c-0.7,0-1.4-0.3-1.8-1l-6.6-11.5c-0.6-1-0.3-2.4,0.9-3C-55.3,138.4-54.9,138.3-54.5,138.3"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M90.6,154.4c-0.3,0-0.7-0.1-1-0.3c-1.1-0.6-1.6-1.9-1-3l6-11.8c0.4-0.8,1.2-1.2,2-1.2c0.3,0,0.7,0.1,1,0.3 c1.1,0.6,1.6,1.9,1,3l-6,11.8C92.2,153.9,91.4,154.4,90.6,154.4"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-28.9,163.4c-0.9,0-1.7-0.5-2.1-1.3l-11.5-27.5c-0.4-1.1,0.1-2.4,1.3-2.9c0.3-0.1,0.6-0.2,0.9-0.2 c0.9,0,1.7,0.5,2.1,1.3l11.5,27.5c0.4,1-0.1,2.3-1.3,2.9C-28.3,163.3-28.6,163.4-28.9,163.4"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M71.3,163.5c-0.3,0-0.6-0.1-0.9-0.2c-1.1-0.4-1.7-1.7-1.3-2.9l11.4-27.5c0.3-0.8,1.1-1.3,2-1.3 c0.3,0,0.6,0.1,1,0.2c1.1,0.4,1.7,1.7,1.3,2.9l-11.4,27.5C72.9,162.9,72.1,163.5,71.3,163.5"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-27.3,126.8c0.2-0.2,0.5-0.4,0.8-0.5c0.3-0.1,0.5-0.1,0.8-0.1c0.9,0,1.7,0.5,2.1,1.4l4.1,12.5 c0.3,1.1-0.3,2.4-1.4,2.9c-0.3,0.1-0.5,0.1-0.8,0.1c-0.9,0-1.7-0.5-2.1-1.4l-4.1-12.5c-0.1-0.2-0.1-0.5-0.1-0.7 C-28.1,127.9-27.8,127.2-27.3,126.8"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M65.9,126.7c0.4-0.4,1-0.7,1.7-0.7c0.2,0,0.3,0,0.5,0.1c1.1,0.3,2,1.6,1.6,2.7l-3.6,12.8 c-0.2,1-1.1,1.6-2.1,1.6c-0.2,0-0.4,0-0.6-0.1c-1.1-0.3-2-1.6-1.6-2.7l3.6-12.8C65.4,127.2,65.6,126.9,65.9,126.7"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-4.7,156c-1.1,0-2-0.8-2.2-1.8l-6-29.2c-0.3-1.1,0.6-2.4,1.7-2.6c0.2,0,0.3-0.1,0.5-0.1 c0.4,0,0.8,0.1,1.1,0.3c0.6,0.3,1,0.8,1.1,1.4l6,29.2c0.3,1.1-0.4,2.3-1.7,2.6C-4.4,156-4.6,156-4.7,156"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M46.6,156c-0.1,0-0.2,0-0.3,0c-1.3-0.3-2-1.4-1.9-2.6l5.8-29.2c0.2-1,1.1-1.8,2.2-1.8c0.2,0,0.3,0,0.5,0.1 c1.3,0.3,2,1.4,1.9,2.6L49,154.3C48.7,155.3,47.7,156,46.6,156"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M6.3,137.4c-1.2,0-2.2-0.8-2.3-1.9l-1.7-13.1c-0.1-1.1,0.7-2.3,2-2.4c0.1,0,0.2,0,0.3,0c1.2,0,2.2,0.8,2.3,1.9 L8.6,135c0.1,1.1-0.7,2.3-2,2.4C6.5,137.4,6.4,137.4,6.3,137.4"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M35.8,137.4c-0.1,0-0.2,0-0.3,0c-1.3-0.1-2.1-1.1-2.1-2.3l1-13.3c0.1-1.1,1-2,2.2-2c0.1,0,0.2,0,0.2,0 c1.3,0.1,2.1,1.1,2.1,2.3l-1,13.3C37.8,136.6,37,137.4,35.8,137.4"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M21.3,153.4c-1.3,0-2.3-1-2.3-2.1v-29.8c0-1.1,1-2.1,2.3-2.1s2.3,1,2.3,2.1v29.8 C23.6,152.4,22.4,153.4,21.3,153.4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafari);
export default __webpack_public_path__ + "static/media/safari.eab28789886d23f938535630d43f1958.svg";
export { ForwardRef as ReactComponent };